// Constant
export const ONE_SECOND = 1000
export const ONE_MINUTE = ONE_SECOND * 60

// By seconds
export const TEN_SECONDS = ONE_SECOND * 10
export const FIFTEEN_SECONDS = ONE_SECOND * 15
export const THIRTY_SECONDS = ONE_SECOND * 30
export const FORTY_FIVE_SECONDS = ONE_SECOND * 45

// By minutes
export const TWO_MINUTES = ONE_MINUTE * 2
export const THREE_MINUTES = ONE_MINUTE * 3
export const FIVE_MINUTES = ONE_MINUTE * 5

// By App Group
export const CHEF_NODE_POLL_INTERVAL = TWO_MINUTES
export const HEALTHSTATUS_POLL_INTERVAL = FIFTEEN_SECONDS
export const DATA_POLL_INTERVAL = ONE_MINUTE